<template>
    <select :disabled="readonly" v-if="load" v-model="displayValue" class="form-control">
        <option v-for="sn in contas" :value="sn._id" v-bind:key="sn._id">
            {{ sn.nome }}
        </option>
    </select>
</template>
<script>
import { Concentrador } from "../../class/concentrador";

export default {
    props: {
        value: {
            default: null
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            contas: [],
            load: false
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    },
    beforeMount() {
        this.loadContas();
    },
    methods: {
        loadContas() {
            Concentrador.all()
                .then(data => {
                    this.contas = data;
                    this.load = true;
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
